import React from 'react';
import CONSTANTS from '../../config/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faChevronDoubleRight } from '@fortawesome/pro-regular-svg-icons';
import find from 'lodash/find';

const CsodTasksBlock = (props) => {
    const { contentFields, width } = props;

    const getContentFieldValue = (fieldDefinitionKey) => {
        const data = find(contentFields, { fieldDefinitionKey });

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }

        return false;
    };

    const getBlockWidth = () => {
        let w = 40;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            const widthValue = getContentFieldValue("Width");
            if (widthValue && widthValue !== CONSTANTS.BLOCK_DEFAULT_WIDTH && widthValue !== w) {
                w = widthValue;
            }
        }

        return w;
    };

    const items = [];

    document.querySelectorAll('[sp-root="YourTasks"] tr').forEach((item, index) => {
        if (index !== 0) {
            const columns = item.querySelectorAll('td');
            const name = columns[0].querySelector('a').innerHTML;
            const link = columns[0].querySelector('a').getAttribute('href');
            const date = columns[1].querySelector('span').innerText;

            items.push({
                name: name,
                link: link,
                date: date
            });
        }
    });

    const data = {
        taskTitle: getContentFieldValue('Title'),
        tasks: items,
        taskLink: 'See all tasks'
    };

    return (
        <section className={"tasks w--" + getBlockWidth() + " show--shadow"}>
            <section className="tasks--inner">
                <h3>
                    <span><FontAwesomeIcon icon={faClipboardList} /></span>
                    <em>{data.taskTitle}</em>
                </h3>
                <ul>
                    {data.tasks.slice(0, 5).map((task, key) => (
                        <li key={key} onClick={() => window.open(task.link, "_blank")}>
                            <em>{task.name}</em>
                            {task.date && <span>Due date: {task.date}</span>}
                        </li>
                    ))}
                    {data.tasks.length === 0 &&
                        <li>
                            <em>No Current Tasks In Progress</em>
                        </li>
                    }
                </ul>
                <a href="/EPM/Scheduler/TaskReview.aspx">
                    {data.taskLink}
                    {' '}
                    <FontAwesomeIcon icon={faChevronDoubleRight} />
                </a>
            </section>
        </section>
    )
};

export default CsodTasksBlock;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/CsodTasksBlock.js